import { PORTRAIT_LOGIN_SOURCE, MINI_PROGRAM_TENDER_LIST_PATH, MINI_PROGRAM_TENDER_DETAIL_PATH } from '@/constants/digitalPortrait.js';

/** 构建千里马小程序 path（仅业务参数，鉴权由小程序 unionId 完成） */
export function buildMiniProgramPath(item) {
	if (item?.contentId != null) {
		const params = new URLSearchParams({ contentId: String(item.contentId) });
		if (item.businessType != null && item.businessType !== '') {
			params.set('businessType', String(item.businessType));
		}
		return `${MINI_PROGRAM_TENDER_DETAIL_PATH}?${params.toString()}`;
	}
	return MINI_PROGRAM_TENDER_LIST_PATH;
}

/** 登录成功后回跳标识，供 digital-portrait-m 解析后跳转千里马小程序 */
export function buildMiniProgramRedirect(item) {
	return `mini:${buildMiniProgramPath(item)}`;
}

/** 构建数字画像移动端登录地址（对齐 PC 端 source + redirect） */
export function buildPortraitLoginUrl(portraitMobileOrigin, item) {
	const base = (portraitMobileOrigin || '').replace(/\/$/, '');
	const redirect = encodeURIComponent(buildMiniProgramRedirect(item));
	return `${base}/qianlimaLogin?source=${PORTRAIT_LOGIN_SOURCE}&redirect=${redirect}`;
}

/**
 * 国械标讯点击跳转：统一进入 digital-portrait-m 登录页，由该侧校验千里马绑定并跳转小程序
 */
export function handleTenderNoticeJump({ item, portraitMobileUrl } = {}) {
	if (!portraitMobileUrl) {
		console.error('未配置数字画像移动端地址 NUXT_PUBLIC_PORTRAIT_MOBILE_URL');
		return { action: 'error', reason: 'missing_portrait_url' };
	}

	window.location.href = buildPortraitLoginUrl(portraitMobileUrl, item);
	return { action: 'portrait_login' };
}
